import * as angular from "angular";
import * as _ from "lodash";
import * as moment from "moment";
import {AgentRequests} from "./services/agent-requests.service";
import {HolderType} from "../commons/types/holder.type";
import {AgentsService} from "./services/agents-service.service";
import {$agentFactory} from "./$agent.factory";
import {QuickFilterContextService} from "../commons/services/quick-filter-context.service";
import {SettingsService} from "../site-preferences/services/settings-service.service";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {ScheduleRequestsService} from "../schedule/services/schedule-requests.service";
import {CommonsService} from "../commons/services/commons-service.service";
import {AgentsFacadeService} from "./angular/state/agents-facade.service";
import {GroupModel} from "../groups/models/group.model";
import {ViewSettingsService} from "../commons/services/view-settings-service.service";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../commons/models/view-settings.model";
import {
  AgentConfigurationProfilesRequestsService
} from "../configuration-profiles/services/agent-configuration-profiles-requests.service";
import {AgentModel} from "./angular/models/agent.model";

angular
  .module('bringoz.admin.agents')
  .config(AgentsConfig);

/* @ngInject */
function AgentsConfig($stateProvider) {

  $stateProvider
    .state('agents-list', {
      parent: 'bringoz.site',
      controllerAs: 'vm',
      url: '/agents?:status&:serviceAreaIds&:noArea&:noBranches&:isActive&:sessionRecording&:termsApproved&:agentSkills&:branchIds&:tags&:gpsStatus&:gpsPermissions&:groupIds&:agentType&:teamIds&:agentIds',
      template: '<agents-list-view branch-ids="vm.branchIds" tags="vm.tags" service-area-ids="vm.serviceAreaIds" is-active="vm.isActive" session-recording="vm.sessionRecording" terms-approved="vm.termsApproved"' +
        ' agent-skills="vm.agentSkills" no-area="vm.noArea" no-branches="vm.noBranches" gps-status="vm.gpsStatus" gps-permissions="vm.gpsPermissions"' +
        'group-ids="vm.groupIds" groups-branch-ids="vm.groupsBranchIds" view-table-settings="vm.viewTableSettings" agent-type="vm.agentType" team-ids="vm.teamIds" agent-ids="vm.agentIds">' +
        '</agents-list-view>',
      controller: function (triBreadcrumbsService, viewFilterSettingsService: ViewFilterSettingsService, $stateParams,
                            commonsService: CommonsService, groups, $state, viewTableSettings: ViewSettingsModel[], site) {

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.selectedQuickFilterId = quickActiveFilter?.id;

        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || quickActiveFilter?.settings.groupIds;
        this.groupsBranchIds = [];

        if (groups.length) {
          groups.forEach((g: GroupModel) => {
            if (g.branchIds?.length) {
              this.groupsBranchIds = this.groupsBranchIds.concat(g.branchIds);
            }
          });
        }

        this.branchIds = _.uniq(this.groupsBranchIds.concat(commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || viewFilterSettingsService.getBranchIds() || []));
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || quickActiveFilter?.settings.serviceAreaIds || viewFilterSettingsService.getServiceAreaIds() || [];
        this.isActive = !_.isUndefined($stateParams.isActive) ? JSON.parse($stateParams.isActive) : quickActiveFilter?.settings.isActive;
        this.sessionRecording = !_.isUndefined($stateParams.sessionRecording) ? JSON.parse($stateParams.sessionRecording) : quickActiveFilter?.settings.sessionRecording;
        this.termsApproved = !_.isUndefined($stateParams.termsApproved) ? JSON.parse($stateParams.termsApproved) : quickActiveFilter?.settings.termsApproved;
        this.agentSkills = commonsService.parseArrayStateParam($stateParams.agentSkills) || quickActiveFilter?.settings.agentSkills;
        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || quickActiveFilter?.settings.tags;
        this.noArea = !_.isUndefined($stateParams.noArea) ? JSON.parse($stateParams.noArea) : quickActiveFilter?.settings.noArea;
        this.noBranches = !_.isUndefined($stateParams.noBranches) ? JSON.parse($stateParams.noBranches) : quickActiveFilter?.settings.noBranches;
        this.gpsPermissions = commonsService.parseArrayStateParam($stateParams.gpsPermissions) || quickActiveFilter?.settings.gpsPermissions;
        this.gpsStatus = !_.isUndefined($stateParams.gpsStatus) ? JSON.parse($stateParams.gpsStatus) : quickActiveFilter?.settings.gpsStatus;
        this.agentType = $stateParams.agentType || quickActiveFilter?.settings.agentType;
        this.teamIds = commonsService.parseArrayStateParam($stateParams.teamIds) || quickActiveFilter?.settings.teamIds || [];
        this.agentIds = $stateParams.agentIds || quickActiveFilter?.settings.agentIds || [];

        const userViewTableSettings = viewTableSettings.find(v => v.holderType === ViewSettingsHolderType.User);

        if (userViewTableSettings) {
          this.viewTableSettings = userViewTableSettings
        } else {
          this.viewTableSettings = viewTableSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Drivers'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      },
      resolve: {
        groups: function ($groups, $stateParams, site) {
          return $stateParams.groupIds?.length ? $groups().$asyncValues($stateParams.groupIds) : [];
        },
        viewTableSettings: function (viewSettingsService: ViewSettingsService, $state, site) {
          return viewSettingsService.getByUser('agents-list', ViewSettingsType.ViewTable);
        }
      }
    })
    .state('agents-payment-collection', {
      parent: 'bringoz.site',
      url: '/agents-payment-collection',
      controllerAs: 'vm',
      template: '<agents-payment-transactions-view branch-ids="vm.branchIds"></agents-payment-transactions-view>',
      controller: function (triBreadcrumbsService, $stateParams, commonsService: CommonsService, site) {

        this.branchIds = $stateParams.branchIds ? commonsService.parseArrayStateParam($stateParams.branchIds) : [];

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Payment Collection'});
        triBreadcrumbsService.addCrumb({name: 'Fleet Management'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      }
    })
    .state('agents-pending-list', {
      parent: 'bringoz.site',
      url: '/pending-agents',
      template: '<agents-pending-list-view></agents-pending-list-view>',
      controller: function (triBreadcrumbsService, site) {
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Driver Applications', state: 'agents-pending-list'});
        triBreadcrumbsService.addCrumb({name: 'Fleet Management'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      }
    })
    .state('agents-itinerary', {
      parent: 'bringoz.site',
      url: '/itineraries?:branchIds&:agentSkills&:tags&:groupIds&:teamIds&:agentIds',
      template: '<agents-itineraries-view selected-quick-filter-id="vm.selectedQuickFilterId" agent-ids="vm.agentIds" branch-ids="vm.branchIds" agent-skills="vm.agentSkills" tags="vm.tags"' +
        'group-ids="vm.groupIds" groups-branch-ids="vm.groupsBranchIds" team-ids="vm.teamIds"></agents-itineraries-view>',
      controllerAs: 'vm',
      controller: function (site, $state, $stateParams,
                            viewFilterSettingsService: ViewFilterSettingsService, groups, commonsService: CommonsService) {
        const currentState = $state.current.name;
        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.selectedQuickFilterId = quickActiveFilter?.id;

        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || quickActiveFilter?.settings.groupIds;
        this.groupsBranchIds = [];

        if (groups.length) {
          groups.forEach((g: GroupModel) => {
            if (g.branchIds?.length) {
              this.groupsBranchIds = this.groupsBranchIds.concat(g.branchIds);
            }
          });
        }

        this.agentSkills = commonsService.parseArrayStateParam($stateParams.agentSkills) || quickActiveFilter?.settings.agentSkills || [];
        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || quickActiveFilter?.settings.tags || [];
        this.branchIds = _.uniq(this.groupsBranchIds.concat(commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || viewFilterSettingsService.getBranchIds() || []));
        this.teamIds = commonsService.parseArrayStateParam($stateParams.teamIds) || quickActiveFilter?.settings.teamIds || [];
        this.agentIds = commonsService.parseArrayStateParam($stateParams.agentIds) || quickActiveFilter?.settings.agentIds;
        // That's the old url patch (for not breaking the google analytics)
        if (currentState === 'agents-itinerary') {
          $state.go('agents-itinerary.list', {}, {notify: true, reload: false, location: 'replace'})
        }
      },
      resolve: {
        groups: function ($groups, $stateParams, site) {
          return $stateParams.groupIds?.length ? $groups().$asyncValues($stateParams.groupIds) : [];
        }
      }
    })
    .state('agents-itinerary.list', {
      url: '/list?:agentId?',
      template: '<agents-itineraries-list-view agents-group="vm.settings.agentsGroup" ' +
        'branch-ids="$ctrl.filtersConfig.bringozFilters.branchIds" ' +
        'agent-skills="$ctrl.filtersConfig.bringozFilters.agentSkills" ' +
        'tags="$ctrl.filtersConfig.bringozFilters.tags" ' +
        'team-ids="$ctrl.filtersConfig.bringozFilters.teamIds" ' +
        'agent-ids="$ctrl.filtersConfig.bringozFilters.agentIds" ' +
        'query-string="$ctrl.filtersConfig.queryString"></agents-itineraries-list-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, splitService, site) {

        this.settings = splitService.getSiteItinerarySettings(site.id);

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Driver Tracking"});
        triBreadcrumbsService.addCrumb({name: "Dispatch"});
      }
    })

    .state('agents-itinerary.timeline', {
      url: '/timeline',
      controllerAs: 'vm',
      template: '<agents-itineraries-timeline-view agents-group="vm.settings.agentsGroup" ' +
        'branch-ids="$ctrl.filtersConfig.bringozFilters.branchIds" ' +
        'agent-skills="$ctrl.filtersConfig.bringozFilters.agentSkills" ' +
        'agent-ids="$ctrl.filtersConfig.bringozFilters.agentIds" ' +
        'query-string="$ctrl.filtersConfig.queryString"></agents-itineraries-timeline-view>',
      controller: function (triBreadcrumbsService, splitService, site) {

        this.settings = splitService.getSiteItinerarySettings(site.id);

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Driver Tracking"});
        triBreadcrumbsService.addCrumb({name: "Dispatch"});
      }
    })

    .state('agents-schedule-management-new', {
      parent: 'bringoz.site',
      url: '/agents-schedule-management-new?:from&:to&:size&:page&:branchIds&:serviceAreaIds&:teamIds&:agentIds&:agentsGroup&:agentType&:vehicleTypes&:employmentType&:agentSkills' +
        '&:agentAssistant&:dateRangeTemplateType&:isFavouriteAgentsMode&:sortType',
      controllerAs: 'vm',
      template: '<agents-shift-management-view-new agents-group="vm.agentsGroup" from="vm.from" to="vm.to" size="vm.size" page="page" ' +
        'branch-ids="vm.branchIds" service-area-ids="vm.serviceAreaIds" team-ids="vm.teamIds" agent-ids="vm.agentIds" agent-type="vm.agentType" employment-type="vm.employmentType" vehicle-types="vm.vehicleTypes" ' +
        'agent-skills="vm.agentSkills" agent-assistant="vm.agentAssistant" is-favourite-agents-mode="vm.isFavouriteAgentsMode" ' +
        'sort-type="vm.sortType" selected-quick-filter-id="vm.selectedQuickFilterId" absence-reasons="vm.absenceReasons"></agents-shift-management-view-new>',
      controller: function (triBreadcrumbsService, commonsService: CommonsService, $stateParams, quickFilterContextService: QuickFilterContextService,
                            dateRangeTimeFiltersService: DateRangeTimeFiltersService, viewFilterSettingsService: ViewFilterSettingsService, $state, site, absenceReasons) {
        this.absenceReasons = absenceReasons;
        this.agentsGroup = $stateParams.agentsGroup;
        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType;

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        } else if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        } else {
          this.from = undefined;
          this.to = undefined;
        }

        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.size = $stateParams.size ? parseInt($stateParams.size) : undefined;
        this.page = $stateParams.page;
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings?.branchIds || viewFilterSettingsService.getBranchIds() || [];
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || quickActiveFilter?.settings.serviceAreaIds || viewFilterSettingsService.getServiceAreaIds() || [];
        this.teamIds = commonsService.parseArrayStateParam($stateParams.teamIds) || quickActiveFilter?.settings.teamIds || [];
        this.agentIds = commonsService.parseArrayStateParam($stateParams.agentIds) || quickActiveFilter?.settings.agentIds;
        this.agentType = $stateParams.agentType || quickActiveFilter?.settings.agentType;
        this.agentSkills = commonsService.parseArrayStateParam($stateParams.agentSkills) || quickActiveFilter?.settings.agentSkills || [];
        this.isFavouriteAgentsMode = !!$stateParams.isFavouriteAgentsMode ? JSON.parse($stateParams.isFavouriteAgentsMode) : false;
        this.sortType = $stateParams.sortType;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Shift Management"});
        triBreadcrumbsService.addCrumb({name: "Resources"});
      },
      resolve: {
        absenceReasons: function (site, settingsService: SettingsService) {
          return settingsService.getAbsenceReasons();
        }
      }
    })

    .state('agents-schedule-new', {
      parent: 'bringoz.site',
      url: '/agents-schedule-new?:from&:to&:size&:page&:branchIds&:tags&:serviceAreaIds&:agentIds&:agentsGroup&:agentType&:agentSkills' +
        '&:agentAssistant&:dateRangeTemplateType&:isFavouriteAgentsMode&:isSortMode&:scheduleTypes',
      controllerAs: 'vm',
      template: '<agents-schedule-view-new agents-group="vm.agentsGroup" from="vm.from" to="vm.to" size="vm.size" page="page" ' +
        'branch-ids="vm.branchIds" tags="vm.tags" service-area-ids="vm.serviceAreaIds" agent-ids="vm.agentIds" agent-type="vm.agentType" ' +
        'agent-skills="vm.agentSkills" agent-assistant="vm.agentAssistant" is-favourite-agents-mode="vm.isFavouriteAgentsMode" ' +
        'is-sort-mode="vm.isSortMode" selected-quick-filter-id="vm.selectedQuickFilterId" view-settings="vm.viewSettings" ' +
        'schedule-types="vm.scheduleTypes"></agents-schedule-view-new>',
      controller: function (triBreadcrumbsService, commonsService: CommonsService, $stateParams, quickFilterContextService: QuickFilterContextService,
                            dateRangeTimeFiltersService: DateRangeTimeFiltersService, viewFilterSettingsService: ViewFilterSettingsService, viewSettings, $state, site) {
        this.agentsGroup = $stateParams.agentsGroup;
        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType;

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        } else if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        } else {
          this.from = undefined;
          this.to = undefined;
        }


        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.size = $stateParams.size ? parseInt($stateParams.size) : undefined;
        this.page = $stateParams.page;
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || viewFilterSettingsService.getBranchIds() || [];
        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || quickActiveFilter?.settings.tags || [];
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || quickActiveFilter?.settings.serviceAreaIds || viewFilterSettingsService.getServiceAreaIds() || [];
        this.agentIds = commonsService.parseArrayStateParam($stateParams.agentIds) || quickActiveFilter?.settings.agentIds;
        this.agentType = $stateParams.agentType || quickActiveFilter?.settings.agentType;
        this.agentSkills = commonsService.parseArrayStateParam($stateParams.agentSkills) || quickActiveFilter?.settings.agentSkills || [];
        this.agentAssistant = !!$stateParams.agentAssistant ? JSON.parse($stateParams.agentAssistant) : quickActiveFilter?.settings.agentAssistant;
        this.isFavouriteAgentsMode = !!$stateParams.isFavouriteAgentsMode ? JSON.parse($stateParams.isFavouriteAgentsMode) : false;
        this.isSortMode = !!$stateParams.isSortMode ? JSON.parse($stateParams.isSortMode) : true;
        this.scheduleTypes = commonsService.parseArrayStateParam($stateParams.scheduleTypes) || quickActiveFilter?.settings.scheduleTypes || [];

        const userViewSettings = viewSettings?.reverse().find(v => v.holderType === ViewSettingsHolderType.User);

        if (userViewSettings) {
          this.viewSettings = userViewSettings
        } else {
          this.viewSettings = userViewSettings?.find(v => v.holderType === ViewSettingsHolderType.Site);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Agents Shifts"});
        triBreadcrumbsService.addCrumb({name: "Planning"});
      },
      resolve: {
        viewSettings: function (viewSettingsService: ViewSettingsService, $state, site) {
          return viewSettingsService.getByUser('agents-schedule-new', ViewSettingsType.ViewTable);
        }
      }
    })

    .state('agents-schedule-beta', {
      parent: 'bringoz.site',
      url: '/agents-schedule-beta?:from&:to&:size&:page&:branchIds&:tags&:serviceAreaIds&:agentIds&:agentsGroup&:agentType&:agentSkills' +
        '&:agentAssistant&:dateRangeTemplateType&:isFavouriteAgentsMode&:isSortMode&:scheduleTypes',
      controllerAs: 'vm',
      template: '<agents-schedule-view-beta agents-group="vm.agentsGroup" from="vm.from" to="vm.to" size="vm.size" page="page" ' +
        'branch-ids="vm.branchIds" tags="vm.tags" service-area-ids="vm.serviceAreaIds" agent-ids="vm.agentIds" agent-type="vm.agentType" ' +
        'agent-skills="vm.agentSkills" agent-assistant="vm.agentAssistant" is-favourite-agents-mode="vm.isFavouriteAgentsMode" ' +
        'is-sort-mode="vm.isSortMode" selected-quick-filter-id="vm.selectedQuickFilterId" view-settings="vm.viewSettings" ' +
        'schedule-types="vm.scheduleTypes"></agents-schedule-view-beta>',
      controller: function (triBreadcrumbsService, commonsService: CommonsService, $stateParams, quickFilterContextService: QuickFilterContextService,
                            dateRangeTimeFiltersService: DateRangeTimeFiltersService, viewFilterSettingsService: ViewFilterSettingsService, viewSettings, $state, site) {
        this.agentsGroup = $stateParams.agentsGroup;
        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType;

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        } else if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        } else {
          this.from = undefined;
          this.to = undefined;
        }


        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.size = $stateParams.size ? parseInt($stateParams.size) : undefined;
        this.page = $stateParams.page;
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || viewFilterSettingsService.getBranchIds() || [];
        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || quickActiveFilter?.settings.tags || [];
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || quickActiveFilter?.settings.serviceAreaIds || viewFilterSettingsService.getServiceAreaIds() || [];
        this.agentIds = commonsService.parseArrayStateParam($stateParams.agentIds) || quickActiveFilter?.settings.agentIds;
        this.agentType = $stateParams.agentType || quickActiveFilter?.settings.agentType;
        this.agentSkills = commonsService.parseArrayStateParam($stateParams.agentSkills) || quickActiveFilter?.settings.agentSkills || [];
        this.agentAssistant = !!$stateParams.agentAssistant ? JSON.parse($stateParams.agentAssistant) : quickActiveFilter?.settings.agentAssistant;
        this.isFavouriteAgentsMode = !!$stateParams.isFavouriteAgentsMode ? JSON.parse($stateParams.isFavouriteAgentsMode) : false;
        this.isSortMode = !!$stateParams.isSortMode ? JSON.parse($stateParams.isSortMode) : true;
        this.scheduleTypes = commonsService.parseArrayStateParam($stateParams.scheduleTypes) || quickActiveFilter?.settings.scheduleTypes || [];

        const userViewSettings = viewSettings?.reverse().find(v => v.holderType === ViewSettingsHolderType.User);

        if (userViewSettings) {
          this.viewSettings = userViewSettings
        } else {
          this.viewSettings = userViewSettings?.find(v => v.holderType === ViewSettingsHolderType.Site);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Agents Shifts"});
        triBreadcrumbsService.addCrumb({name: "Planning"});
      },
      resolve: {
        viewSettings: function (viewSettingsService: ViewSettingsService, $state, site) {
          return viewSettingsService.getByUser('agents-schedule-new', ViewSettingsType.ViewTable);
        }
      }
    })

    // Import Agent Schedules View
    .state('agents-schedule-import', {
      parent: 'bringoz.site',
      url: '/agents-schedule-import',
      template: '<agent-schedule-import-view></agent-schedule-import-view>',
      controller: function (triBreadcrumbsService) {
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Import Agent Schedules'});
        triBreadcrumbsService.addCrumb({name: 'Agents Shifts', state: 'agents-schedule-beta'});
        triBreadcrumbsService.addCrumb({name: 'Planning'});
      }
    })


    .state('agent-locations-view', {
      parent: 'bringoz.site',
      url: '/agent-locations',
      template: '<agent-locations-view></agent-locations-view>',
      controller: function (triBreadcrumbsService, site) {
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Agent Locations'});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    //Agent details
    .state('agent', {
      parent: 'bringoz.site',
      url: '/agent/:id',
      abstract: true,
      controllerAs: 'vm',
      template: '<agent-detailed-view agent-id="vm.agentId"></agent-detailed-view>',
      controller: function ($scope, $agent: $agentFactory, triBreadcrumbsService, agent, agentId, agentConfigurationProfile, site) {

        this.agentId = agentId;
        this.agentConfigurationProfile = agentConfigurationProfile;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: agent.user.firstName + ' ' + agent.user.lastName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Drivers', state: 'agents-list'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      },
      resolve: {
        agentId: function ($agent: $agentFactory, $stateParams, agentsFacadeService: AgentsFacadeService, site) {
          agentsFacadeService.getOne($stateParams.id)
          return $stateParams.id;
        },
        agent: function (agentRequests, $agent: $agentFactory, agentId) {
          return $agent(agentId).$instantGet();
        },
        agentConfigurationProfile: function (agentConfigurationProfilesRequestsService: AgentConfigurationProfilesRequestsService, agentId) {
          return agentConfigurationProfilesRequestsService.getConfigurationByAgent(agentId);
        }
      }
    })

    // Agent Profile - Main
    .state('agent.agent-profile', {
      url: '/profile',
      pageTrack: '/agent/profile',
      template: '<agent-profile agent="$ctrl.agent"></agent-profile>'
    })

    .state('agent.agent-profile.vehicles', {
      url: '/vehicles',
      pageTrack: '/agent/profile/vehicles',
      template: '<agent-vehicles-view agent="$ctrl.agent"></agent-vehicles-view>'
    })

    // Registration Vehicles - USED?
    .state('agent.agent-profile.registration-vehicles', {
      url: '/registration-vehicles',
      pageTrack: '/agent/profile/registration-vehicles',
      template: '<account-vehicles loading="loading" selected-vehicle="selectedVehicle" account="$ctrl.agent.account"></account-vehicles>'
    })

    // Requirements
    .state('agent.agent-profile.requirements', {
      url: '/requirements/:requirementId',
      pageTrack: '/agent/profile/requirements',
      template: '<agent-requirements agent="$ctrl.agent" requirements="requirements" '
        + 'requirement-types="requirementTypes" selected-vehicle="selectedVehicle" '
        + 'selected-requirement="selectedRequirement"></agent-requirements>'
    })

    // Preferences
    .state('agent.agent-profile.preferences', {
      url: '/preferences',
      pageTrack: '/agent/profile/preferences',
      template: '<agent-preferences agent="$ctrl.agent" preferences="preferences">',
      controller: function ($scope, preferences) {
        $scope.preferences = preferences ? preferences : {modules: {}};
      },
      resolve: {
        preferences: function (agentId: string, agentRequests: AgentRequests) {
          return agentRequests.getAgentPreferences(agentId);
        }
      }
    })

    // App Features
    .state('agent.agent-profile.app-features', {
      url: '/app-features',
      pageTrack: '/agent/profile/app-features',
      template: '<agent-app-features agent="$ctrl.agent" preferences="preferences">',
      controller: function ($scope, preferences) {
        $scope.preferences = preferences ? preferences : {modules: {}};
      },
      resolve: {
        preferences: function (agentId: string, agentRequests: AgentRequests) {
          return agentRequests.getAgentPreferences(agentId);
        }
      }
    })

    // Branches
    .state('agent.agent-profile.branches', {
      url: '/branches',
      pageTrack: '/agent/profile/branches',
      template: '<agent-branches agent="$ctrl.agent"></agent-branches>'
    })

    // Service Areas
    .state('agent.agent-profile.service-areas', {
      url: '/service-areas',
      pageTrack: '/agent/profile/service-areas',
      template: '<agent-service-areas agent="$ctrl.agent" preferences="preferences"></agent-service-areas>',
      controller: function ($scope, preferences) {
        $scope.preferences = preferences ? preferences : {modules: {}};
      },
      resolve: {
        preferences: function (agentId: string, agentRequests: AgentRequests) {
          return agentRequests.getAgentPreferences(agentId);
        }
      }
    })

    // Schedule
    .state('agent.agent-profile.schedule', {
      url: '/schedule',
      pageTrack: '/agent/profile/schedule',
      template: '<agent-schedule-view agent="$ctrl.agent" from="vm.from" to="vm.to"' +
        'selected-template="vm.selectedTemplate" absence-reasons="vm.absenceReasons"></agent-schedule-view>',
      controllerAs: 'vm',
      controller: function (template, absenceReasons) {
        this.from = moment().startOf('week').valueOf();
        this.to = moment().endOf('week').valueOf();
        this.selectedTemplate = template;
        this.absenceReasons = absenceReasons;
      },
      resolve: {
        // schedule: function (agentId, scheduleService) {
        //   let from = moment().startOf('week').valueOf();
        //   let to = moment().endOf('week').valueOf();
        //   return scheduleService.getByAgentId(from, to, agentId);
        //   // return scheduleService.getAll(from, to, undefined, agentId);
        // },
        absenceReasons: function (site, settingsService: SettingsService) {
          return settingsService.getAbsenceReasons();
        },
        template: function (agent, $q, scheduleRequestsService: ScheduleRequestsService) {
          return agent.scheduleId && !_.isEqual(agent.scheduleId, agent.id) ? scheduleRequestsService.getTemplateById(agent.scheduleId) : $q.when();
        }
      }
    })

    .state('agent.timecards', {
      url: '/timecards:from&:to',
      pageTrack: '/agent/timecards',
      controllerAs: 'vm',
      template: '<timecard-detail-view is-agent-view="true" agent-id="$ctrl.agent.id" from-date="vm.fromDate" to-date="vm.toDate"></timecard-detail-view>',
      controller: function (agent, $stateParams, triBreadcrumbsService) {
        this.fromDate = $stateParams.from ? parseInt($stateParams.from) : moment().startOf('day').valueOf();
        this.toDate = $stateParams.to ? parseInt($stateParams.to) : moment().endOf('day').valueOf();

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Timecards'});
        triBreadcrumbsService.addCrumb({name: agent.user.firstName + ' ' + agent.user.lastName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Drivers', state: 'agents-list'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      }
    })

    .state('agent.history', {
      url: '/history',
      pageTrack: '/agent/history',
      template: '<agent-delivery-history agent-id="$ctrl.agent.id"></agent-delivery-history>'
    })
    .state('agent.active', {
      url: '/active',
      pageTrack: '/agent/active',
      template: '<agent-delivery-active agent-id="$ctrl.agent.id"></agent-delivery-active>'
    })
    .state('agent.itinerary', {
      url: '/itinerary',
      pageTrack: '/agent/itinerary',
      template: '<agent-itinerary-view-new agent="$ctrl.agent" agent-configuration-profile="$ctrl.agentConfigurationProfile"></agent-itinerary-view-new>'
    })

    .state('agent.report', {
      abstract: true,
      url: '/reports',
      reloadOnSearch: false,
      template: '<account-commissions-view></account-commissions-view>',
    })
    // url: '/services?:servicesIds&:siteId&:printTaskPurpose',
    .state('agent.report.expenses', {
      url: '/expenses?:categoryIds&:statuses&:accountIds&:from&:to&:query',
      params: {
        categoryIds: null,
        statuses: null,
        accountIds: null,
        from: null,
        to: null,
        query: null
      },
      pageTrack: '/agent/report/expenses',
      template: '<expenses-view  account-ids="vm.accountIds" agent-ids="vm.agentIds" category-ids="vm.categoryIds" statuses="vm.statuses"' +
        ' from="vm.from" to="vm.to" query="vm.query" ></expenses-view>',
      controllerAs: 'vm',
      controller: function (agent, $stateParams) {
        this.agentIds = [agent.id]
        this.accountIds = $stateParams.accountIds;
        this.categoryIds = $stateParams.categoryIds;
        this.statuses = $stateParams.statuses;
        this.from = parseInt($stateParams.from);
        this.to = parseInt($stateParams.to);
        this.query = $stateParams.query;
      }
    })

    .state('agent.report.commissions', {
      url: '/commissions?:serviceStatuses',
      pageTrack: '/agent/report/commissions',
      template: '<commissions-view account="vm.agent.account" agent-id="vm.agent.id" service-statuses="vm.serviceStatuses" enable-totals="true"></commissions-view>',
      controllerAs: 'vm',
      controller: function (commonsService: CommonsService, $stateParams, agent) {
        this.serviceStatuses = commonsService.parseArrayStateParam($stateParams.serviceStatuses);
        this.agent = agent;
      }
    })

    // .state('agent.report.consolidated-commissions', {
    //   url: '/consolidated-commissions',
    //   pageTrack: '/agent/report/consolidated-commissions',
    //   template: '<consolidated-commissions-view account-id="vm.agent.account.id"></consolidated-commissions-view>',
    //   controllerAs: 'vm',
    //   controller: function (agent) {
    //     this.agent = agent;
    //   }
    // })

    .state('agent.working-slots', {
      url: '/working-slots',
      pageTrack: '/agent/working-slots',
      template: '<agent-working-slots agent="$ctrl.agent"></agent-working-slots>'
    })
    .state('agent.contact', {
      url: '/contact',
      pageTrack: '/agent/contact',
      template: '<contact-user-view user="$ctrl.agent.user"></contact-user-view>'
    })

    .state('agent.documents-and-reminders', {
      url: '/documents-and-reminders',
      pageTrack: '/agent/documents-and-reminders',
      template: '<agent-documents-and-reminders agent="$ctrl.agent"' +
        ' documents-settings="documentsSettings" documents="documents" reminders-settings="remindersSettings"' +
        ' reminders="reminders"></agent-documents-and-reminders>',
      controller: function ($scope, documentsSettings, documents, remindersSettings, reminders) {
        $scope.documentsSettings = documentsSettings;
        $scope.documents = documents;

        $scope.remindersSettings = remindersSettings;
        $scope.reminders = reminders;

      },
      resolve: {
        documentsSettings: function (settingsService: SettingsService, site) {
          return settingsService.getAllDocuments(HolderType.AGENT)
        },
        documents: function (agentsService: AgentsService, agent, site) {
          return agentsService.getDocuments(agent.id)
        },
        remindersSettings: function (settingsService: SettingsService, site) {
          return settingsService.getAllReminders(HolderType.AGENT)
        },
        reminders: function (agentsService: AgentsService, agent, site) {
          return agentsService.getReminders(agent.id)
        },
      },

    })

    // Account / Inventory Transactions
    .state('agent.inventory-transactions', {
      url: '/inventory-transactions',
      pageTrack: '/agent/inventory-transactions',
      controllerAs: 'vm',
      template: '<agent-inventory-transactions-view agent="$ctrl.agent"></agent-inventory-transactions-view>',
      controller: function (agent: AgentModel, triBreadcrumbsService) {
        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Inventory Transactions'});
        triBreadcrumbsService.addCrumb({name: agent.user.firstName + ' ' + agent.user.lastName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Drivers', state: 'agents-list'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      }
    })


    //Upload Agents View
    .state('agents-upload', {
      parent: 'bringoz.site',
      url: '/agents-upload',
      template: '<upload-agents-view></upload-agents-view>',
      controller: function (triBreadcrumbsService, site) {

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Upload Agents"});
        triBreadcrumbsService.addCrumb({name: "Resources"});
      }
    })

    .state('agents-performance', {
      url: '/agents-performance?&:tags&:branchIds&:agentSkills&:agentId',
      parent: 'bringoz.site',
      template: '<agents-performance-view agents-group="vm.settings.agentsGroup" selected-quick-filter-id="vm.selectedQuickFilterId" ' +
        'tags="vm.tags" branch-ids="vm.branchIds" agent-skills="vm.agentSkills" agent-id="vm.agentId"></agents-performance-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, splitService, viewFilterSettingsService: ViewFilterSettingsService, commonsService: CommonsService, $stateParams, $state, site) {
        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);

        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.settings = splitService.getSiteItinerarySettings(site.id);

        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || quickActiveFilter?.settings.tags || [];
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || viewFilterSettingsService.getBranchIds() || [];
        this.agentSkills = commonsService.parseArrayStateParam($stateParams.agentSkills) || quickActiveFilter?.settings.agentSkills || [];
        this.agentId = $stateParams.agentId;


        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Agents Performance"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })


}
